module.exports = __webpack_public_path__ + "static/Group 469-3d6345e93e8859450aaa02a1e4c5ca22.png";